import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ReusableDataTable from "../hooks/ReusableDataTable";
import { Button } from "flowbite-react";
import { IoMdDownload } from "react-icons/io";
import { useSidebar } from "../context/SidebarOpenContext";

function BillingPage() {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { isSidebarOpen } = useSidebar();

    useEffect(() => {
        const controller = new AbortController(); // To cancel on unmount
        const fetchBillDetails = async () => {
            try {
                setLoading(true);
                const response = await axios.get("/billing/order/get_all_completed_bill_details", {
                    signal: controller.signal,
                    timeout: 10000, // ⏱ Optional timeout of 10s
                });
                if (response?.data && Array.isArray(response.data)) {
                    setOrders(response.data);
                } else {
                    setOrders([]);
                    console.warn("Invalid data structure:", response.data);
                }
            } catch (err) {
                if (axios.isCancel(err)) {
                    console.log("Request canceled:", err.message);
                } else {
                    setError("Failed to fetch billing details.");
                    console.error("Error fetching billing details:", err);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchBillDetails();

        return () => controller.abort(); // Cleanup fetch on unmount
    }, []);

    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true },
        { name: "Order No", selector: (row) => row.cut_order_no, sortable: true },
        { name: "Buyer Name", selector: (row) => row.buyer_name, sortable: true },
        { name: "Boxing Type", selector: (row) => row.boxing_type, sortable: true },
        {
            name: "Order Date",
            selector: (row) => row.order_date ? new Date(row.order_date).toLocaleDateString() : "-",
            sortable: true,
        },
        {
            name: "Delivery Date",
            selector: (row) => row.delivery_date ? new Date(row.delivery_date).toLocaleDateString() : "-",
            sortable: true,
        },
        {
            name: "Print Bill",
            cell: (row) => (
                <Button
                    color="gray"
                    size="lg"
                    onClick={() => navigate(`/billing/print/${row.order_id}`)}
                >
                    <IoMdDownload className="h-5 w-5" />
                </Button>
            )
        }
    ];

    return (
        <div className={`${isSidebarOpen ? "p-4 sm:ml-64" : "p-4"} bg-content-bg min-h-screen`}>
            <div className="p-4 rounded-lg mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    {loading ? (
                        <div className="text-center py-8 text-gray-600 font-medium">Loading...</div>
                    ) : error ? (
                        <div className="text-center py-8 text-red-600 font-medium">{error}</div>
                    ) : (
                        <ReusableDataTable
                            title="Completed Orders"
                            columns={columns}
                            data={orders}
                            noDataMessage="Boxing Not Completed"
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default BillingPage;
